import { Link } from "react-router-dom";

const bundles = [
  {
    id: "front-office",
    price: "€990",
    save: "Save €380/mo",
    icon: "ri-building-2-line",
    title: "AI Front Office",
    description:
      "Everything you need to automate your client-facing operations. From first contact to booked appointment — completely hands-free.",
    tags: ["AI Intake Agent", "AI Appointment Maker", "AI Knowledge Assistant"],
    cta: "bg-white/8 text-white border border-white/10 hover:bg-white/15",
    ctaText: "Get Started",
    popular: false,
  },
  {
    id: "document-suite",
    price: "€890",
    save: "Save €190/mo",
    icon: "ri-folder-3-line",
    title: "AI Document Suite",
    description:
      "Turn your document chaos into clarity. Perfect for document-heavy businesses like law firms and consulting practices.",
    tags: ["AI Document Intelligence", "AI Knowledge Assistant"],
    cta: "bg-white/8 text-white border border-white/10 hover:bg-white/15",
    ctaText: "Get Started",
    popular: false,
  },
  {
    id: "full-stack",
    price: "€1,690",
    save: "Save €770/mo",
    icon: "ri-rocket-2-line",
    title: "AI Full Stack",
    description:
      "The complete AI workforce. All four modules working together to transform every part of your operations.",
    tags: ["AI Intake Agent", "AI Appointment Maker", "AI Document Intelligence", "AI Knowledge Assistant"],
    cta: "bg-electric-500 text-white hover:bg-electric-600",
    ctaText: "Get Started",
    popular: true,
  },
];

export default function BundlesSection() {
  return (
    <section className="py-24 bg-[#040810]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-electric-400 text-xs font-semibold uppercase tracking-widest">Bundled Workflows</span>
          <h2 className="mt-3 text-4xl lg:text-5xl font-extrabold text-white leading-tight">
            Complete Workflows.{" "}
            <span className="text-electric-400">Maximum Impact.</span>
          </h2>
          <p className="mt-4 text-slate-400 text-lg">
            Bundle modules together and save — while getting more done, faster.
          </p>
        </div>

        <div className="flex flex-col gap-5">
          {bundles.map((bundle) => (
            <div
              key={bundle.id}
              id={bundle.id}
              className={`relative group rounded-2xl border transition-all duration-300 ${
                bundle.popular
                  ? "bg-gradient-to-r from-electric-500/10 via-[#0D1628] to-[#0D1628] border-electric-500/30 hover:border-electric-500/50"
                  : "bg-[#0D1628] border-white/8 hover:border-white/15"
              }`}
            >
              {bundle.popular && (
                <div className="absolute -top-3.5 left-8">
                  <span className="px-3 py-1 rounded-full bg-electric-500 text-white text-xs font-bold uppercase tracking-wider">
                    MOST POPULAR
                  </span>
                </div>
              )}
              <div className="p-6 lg:p-8 grid lg:grid-cols-[200px_1fr_auto] gap-6 items-center">
                <div className="flex lg:flex-col items-baseline lg:items-start gap-3 lg:gap-1">
                  <div className="flex items-center gap-1">
                    <span className="text-4xl font-extrabold text-white">{bundle.price}</span>
                  </div>
                  <span className="text-slate-400 text-sm">/month</span>
                  <div className="hidden lg:block">
                    <span className="text-emerald-400 text-sm font-semibold">{bundle.save}</span>
                  </div>
                  <div className="lg:hidden">
                    <span className="text-emerald-400 text-xs font-semibold">{bundle.save}</span>
                  </div>
                </div>

                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-electric-500/15 shrink-0">
                      <i className={`${bundle.icon} text-electric-400 text-lg`}></i>
                    </div>
                    <h3 className="text-white font-bold text-xl">{bundle.title}</h3>
                  </div>
                  <p className="text-slate-400 text-sm leading-relaxed">{bundle.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {bundle.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-3 py-1 rounded-full bg-electric-500/10 border border-electric-500/20 text-electric-300 text-xs font-medium"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col gap-2 items-start lg:items-end">
                  <Link
                    className={`px-6 py-3 rounded-xl font-semibold text-sm whitespace-nowrap cursor-pointer transition-all duration-200 ${bundle.cta}`}
                    to="/contact"
                  >
                    {bundle.ctaText}
                  </Link>
                  <Link
                    className="text-slate-400 text-xs hover:text-electric-400 transition-colors cursor-pointer"
                    to={`/products#${bundle.id}`}
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
